import api from '../../../lib/api';

export default {
  async twilio({ rootState }, {
    content, number, customer, author,
  }) {
    const { companyId } = rootState.auth;

    const { payload } = await api.messages.sendSms(companyId, {
      content, number, customer, author,
    });

    return payload;
  },
};
